module.exports = __webpack_public_path__ + "img/shrimp-and-artichokes-over-linguine.16faefce.jpg";